import React from 'react';
import { Col, Row } from '@saucelabs/sl-component-grid';

import { Subscription } from '../../../records/Subscription';
import { amountSeparator } from '../../../utils/numbers';
import { PriceEntry } from './PriceEntry';
import { MOBILE_QUALITY_LABEL } from '../../../constants';
import Styles from './SubscriptionBoxes.styles';

interface MobileQualitySubscriptionBoxProps {
  subscription: Subscription
}

const MobileQualitySubscriptionBox: React.FC<MobileQualitySubscriptionBoxProps> = ({
  subscription,
}) => {
  const cadence = subscription.getIntervalLabel();

  return (
    <>
      <Row>
        <Col xs={12}>
          <strong className="text-base">
            {`Current Plan: ${MOBILE_QUALITY_LABEL}`}
          </strong>
        </Col>
      </Row>
      <Row>
        <Col
          key={subscription.id}
          xs={8}
        >
          <ul className={Styles.features}>
            <li className="text-gray-600">
              <strong>{subscription.displaySauceFeatureName()}</strong>
              {` (${cadence} plan)`}
            </li>
            <li>
              <PriceEntry
                cadence={cadence}
                nextBillDay={subscription.displayNextBillDate()}
                price={amountSeparator(subscription.getMonthlyPrice())}
              />
            </li>
          </ul>
        </Col>

        <Col xs={4}>
          <div className="mt-0.5 ml-auto text-right">
            <div>
              Current Monthly Rate:
              {' '}
            </div>
            <strong className="text-base">
              {amountSeparator(subscription.getMonthlyPrice())}
            </strong>
          </div>
        </Col>
      </Row>
    </>
  );
};

export { MobileQualitySubscriptionBox };
